<template>
    <div class="fc-display-contents">
        <component
            :is="element.elementType"
            v-for="(element, index) in elementsNew"
            :key="element.id"
            :pointer="index + 1"
            :index="index"
            :element-type="element.elementType"
            v-bind="element"
            is-dynamic-element
            is-dropzone-element
            @click.native.right="event => openCopyMenu(event, element)"
            @cut="onCut({ element, onCutCallback: deleteElement })"
            @copy="onCopy"
            @move-element="moveElement"
            @delete-element="deleteElementByIndex(index)"
            @element-updated="elementUpdated"
            @submit-form="submitForm"
        />
    </div>
</template>

<script>
import dropZoneMixin from '@/mixins/drop-zone';

export default {
    name: 'drop-zone-output',
    mixins: [dropZoneMixin],

    props: {
        elementsNew: {
            type: Array,
            required: true,
        },
    },

    methods: {
        elementUpdated(updatedElement) {
            this.$emit('element-updated', updatedElement);
        },

        submitForm() {
            this.$emit('submit-form');
        },
    },
};
</script>
